import type { RouteRecordRaw } from 'vue-router'

export const CategoryMainViewRoute: RouteRecordRaw = {
  path: '/category',
  name: 'CategoryMainView',
  component: () => import('../ui/CategoryMainView.vue'),
  meta: {}
}
